import React from 'react';

import { withRouter, Route, Switch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import configs from '../../config/consultation.json';
import WebLayout from '../../layouts/WebLayout';
import PageNotFound from '../../modules/common/PageNotFound';
import ConsultationListPanel from './ConsultationListPanel';
import ConsultationContent from './ConsultationContent';
import ConsultationResponse from './ConsultationResponse';
import ConsultationComment from './ConsultationComment';
import ConsultationCommentSuccess from './ConsultationCommentSuccess';

function ConsultationRoute(props) {

    const { i18n } = useTranslation();
    const { match } = props;

    const toList = (props) => {
        const { params } = props.match;

        let cfg = null;
        if (params.urlPath === undefined) {
            cfg = configs.find((item) => item.category === "all");
        } else {
            cfg = configs.find((item) => item.urlPath === params.urlPath);
        }

        if (cfg !== null) {
            i18n.setDefaultNamespace('consultation');

            return (                
                <WebLayout component={ConsultationListPanel}
                    sectionId={cfg.sectionId} pageId={cfg.pageId} category={cfg.categoryKey}/>
            );
        } else {
            return (<PageNotFound/>);
        }
    };

    const toCpDetail = (props, Component) => {
        const { params } = props.match;
        
        let cfg = null;
        if (params.urlPath === undefined) {
            cfg = configs.find((item) => item.category === "all");
        } else {
            cfg = configs.find((item) => item.urlPath === params.urlPath);
        }

        if (cfg !== undefined) {
            const params = new URLSearchParams(props.location.search);
            const refNo = params.get('refNo');
            i18n.setDefaultNamespace('consultation');

            return (
                <WebLayout component={Component} refNo={refNo}
                    sectionId={cfg.sectionId} pageId={cfg.pageId}/>
            );
        } else {
            return (<PageNotFound/>)
        }
    };

    const toContent = (props) => {
        return toCpDetail(props,ConsultationContent);
    }

    const toResponse = (props) => {
        return toCpDetail(props,ConsultationResponse);
    }

    const toComment = (props) => {
        
        const params = new URLSearchParams(props.location.search);
        const refNo = params.get('refNo');
        i18n.setDefaultNamespace('consultation');

        return (
            <WebLayout component={ConsultationComment} refNo={refNo}
                sectionId="18,1027" pageId="224,1037"/>
        );
    }

    const toSubmitSuccess = (props) => {
        
        i18n.setDefaultNamespace('consultation');

        return (
            <WebLayout component={ConsultationCommentSuccess}
                sectionId="18,1027" pageId="224,1037"/>
        );
    }

    const downloadFile = (props, apiUrl) => {
        const { params: routerParams } = props.match;
        
        let cfg = null;
        if (routerParams.urlPath === undefined) {
            cfg = configs.find((item) => item.category === "all");
        } else {
            cfg = configs.find((item) => item.urlPath === routerParams.urlPath);
        }

        if (cfg !== undefined) {
            window.location = apiUrl;
        } else {
            return (<PageNotFound/>);
        }
    }

    const openFile = (props) => {
        const { params: routerParams } = props.match;        
        const urlParams = new URLSearchParams(props.location.search);

        const apiParams = new URLSearchParams();
        apiParams.set("lang",routerParams.lang);
        apiParams.set("refNo",urlParams.get('refNo'));

        const apiUrl = `${process.env['PUBLIC_URL']}/api/consultation/openFile?${apiParams}`

        return downloadFile(props, apiUrl);
    };

    const openAppendix = (props) => {
        const { params: routerParams } = props.match;
        
        const urlParams = new URLSearchParams(props.location.search);
        const lang = routerParams.lang;
        const refNo = urlParams.get('refNo');
        const appendix = urlParams.get('appendix');

        const apiParams = new URLSearchParams();
        apiParams.set("lang",lang);
        apiParams.set("refNo",refNo);
        apiParams.set("appendix",appendix);

        const apiUrl = `${process.env['PUBLIC_URL']}/api/consultation/openAppendix?${apiParams}`;

        return downloadFile(props, apiUrl);
    };

    const openCommentFile = (props) => {
        const urlParams = new URLSearchParams(props.location.search);
        
        const apiParams = new URLSearchParams();        
        apiParams.set("refNo",urlParams.get('refNo'));
        apiParams.set("commentRefNo",urlParams.get('commentRefNo'));

        const apiUrl = `${process.env['PUBLIC_URL']}/api/consultation/openCommentFile?${apiParams}`

        return downloadFile(props, apiUrl);
    };

    const conclusion = (props) => {
        const { params: routerParams } = props.match;        
        const urlParams = new URLSearchParams(props.location.search);
        
        const apiParams = new URLSearchParams();
        apiParams.set("lang",routerParams.lang);
        apiParams.set("refNo",urlParams.get('refNo'));

        const apiUrl = `${process.env['PUBLIC_URL']}/api/consultation/conclusion?${apiParams}`

        return downloadFile(props, apiUrl);
    };

    const openConclusionAppendix = (props) => {
        const { params: routerParams } = props.match;        
        const urlParams = new URLSearchParams(props.location.search);
        
        const apiParams = new URLSearchParams();
        apiParams.set("lang",routerParams.lang);
        apiParams.set("refNo",urlParams.get('refNo'));
        apiParams.set("appendix",urlParams.get('appendix'));

        const apiUrl = `${process.env['PUBLIC_URL']}/api/consultation/openConclusionAppendix?${apiParams}`

        return downloadFile(props, apiUrl);
    };

    return (
        <Switch>
            <Route path={`${match.path}:urlPath*/doc`} 
                render={toContent}/>
            <Route path={`${match.path}:urlPath*/response`} 
                render={toResponse}/>
            <Route path={`${match.path}:urlPath*/openFile`}
                render={openFile}/>
            <Route path={`${match.path}:urlPath*/openAppendix`} 
                render={openAppendix}/>
            <Route path={`${match.path}:urlPath*/openCommentFile`} 
                render={openCommentFile}/>
            <Route path={`${match.path}:urlPath*/conclusion`} 
                render={conclusion}/>
            <Route path={`${match.path}:urlPath*/openConclusionAppendix`} 
                render={openConclusionAppendix}/>
            <Route path={`${match.path}comment`} 
                render={toComment}/>
            <Route path={`${match.path}submitsuccess`} 
                render={toSubmitSuccess}/>
            <Route path={`${match.path}:urlPath*/`} 
                strict exact render={toList}/>
        </Switch>
    );}

export default withRouter(ConsultationRoute);